import Search from './components/Search/Search';

const SearchBar = (props) => {
  const { onSearch, searchData } = props;

  return (
    <Search
      onSearch={(e) => onSearch(e.target.value)}
      searchData={searchData}
    />
  );
};
export default SearchBar;
